import "./CompanyResourceLinks.scss";
import {LinkOutlined} from "@ant-design/icons";
import {useRecoilValue} from "recoil";
import {memberState} from "../state/atoms";

interface CompanyResourceLinksProps {
  onClick?: () => void;
}

const CompanyResourceLinks = ({onClick}: CompanyResourceLinksProps) => {
  const member = useRecoilValue(memberState);

  return (
    <>
      {member.companyResources.map((link, index) => (
        <li key={`${index}-${link.url}`} className="company-resource-link">
          <a href={link.url} target="_blank" rel="noopener noreferrer" title={link.name} onClick={onClick}>
            <LinkOutlined/>
            <span className="company-resource-name">{link.name}</span>
          </a>
        </li>
      ))}
    </>
  );
};

export default CompanyResourceLinks;
